var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15878 16.3619L6.81341 18.0165C6.9916 18.1947 7.14433 18.1947 7.32252 18.0165L11.5737 13.7654L15.723 17.9147C15.9011 18.0929 16.0284 18.0674 16.2066 17.8893L17.6831 16.4128C17.8612 16.2346 17.8867 16.1073 17.7085 15.9292L13.5592 11.7798L17.8103 7.52872C17.9885 7.35053 17.9885 7.1978 17.8103 7.01961L16.1557 5.36498C15.9521 5.16133 15.7993 5.16133 15.6211 5.33952L11.37 9.59065L7.2207 5.44134C7.04251 5.26315 6.91523 5.28861 6.73704 5.4668L5.2606 6.94324C5.08241 7.12143 5.05695 7.24871 5.23515 7.4269L9.38445 11.5762L5.13332 15.8273C4.92967 16.031 4.95513 16.1583 5.15878 16.3619Z",
    fill: "#00567A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.dd3b7ed5321424256f7fd9527a9c2fe2.svg";
export { ForwardRef as ReactComponent };